// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-danger[data-v-23e61c50]{padding-top:20vh}.modal-backdrop[data-v-23e61c50]{display:none}.modal-body[data-v-23e61c50]{display:flex;flex-direction:column;justify-content:space-around;align-items:center}.modal-body .sad-face[data-v-23e61c50]{font-size:5rem;margin-bottom:2rem;font-family:serif}.modal-body p[data-v-23e61c50]{font-size:1.5rem}", ""]);
// Exports
module.exports = exports;
